import type { UserWithKeycloakId } from '@deque/billing-service-client';
import { apiRequest } from '../../../api-client';

/**
 * Walnut wraps the v1 billing-user shape with `stripe_name` (the raw value
 * as seen in Stripe) on top of the overridden `name` field (the Walnut-
 * derived display name). Forms that need to confirm the Stripe-side
 * billing name (e.g. Purchase) should read `stripe_name`.
 */
export type AxeAccountV1MeUser = UserWithKeycloakId & {
  stripe_name?: string | null;
};

export default {
  /**
   * Get the billing data for the logged-in user.
   */
  get(token: string): Promise<AxeAccountV1MeUser> {
    return apiRequest<AxeAccountV1MeUser>({
      endpoint: '/api/billing/me',
      method: 'GET',
      token
    });
  }
};
